import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

import { firebaseConfig } from "./config";
import { logInDev } from "../helpers";

firebase.initializeApp(firebaseConfig);
firebase.analytics();

firebase
  .auth()
  .signInAnonymously()
  .catch((err) => {
    const errorCode = err.errorCode;
    const errorMessage = err.message;
    logInDev("auth error: ", errorCode, errorMessage);
  });

export default firebase;
